import styles from './styles.module.css';
import ArrowIcon from '@/assets/icons/arrow.svg?react';
import DownloadIcon from '@/assets/icons/download2.svg?react';
import DateRangeInput, {
  DateRangeValue
} from '@/components/Form/DateRangeInput';

interface AuditDateControlsProps {
  range: DateRangeValue;
  onRangeChange: (value: DateRangeValue) => void;
  onApply: () => void;
}

export function AuditDateControls({
  range,
  onRangeChange,
  onApply
}: AuditDateControlsProps) {
  return (
    <div className={styles.dateGroup}>
      <DateRangeInput
        id="auditDateRange"
        value={range}
        onChange={onRangeChange}
      />
      <button
        type="button"
        id="auditApplyFilters"
        className={styles.applyButton}
        onClick={onApply}
        aria-label="Apply filters"
      >
        <ArrowIcon width={14} height={14} />
      </button>
    </div>
  );
}

interface AuditDownloadButtonProps {
  onDownload: () => void;
  disabled?: boolean;
}

export function AuditDownloadButton({
  onDownload,
  disabled = false
}: AuditDownloadButtonProps) {
  return (
    <button
      type="button"
      id="auditDownloadCsv"
      className={styles.downloadButton}
      onClick={onDownload}
      disabled={disabled}
    >
      <DownloadIcon width={14} height={14} />
      Download CSV
    </button>
  );
}
